/**
 * The phone app's words for its navigation and its Home screen (piece 35, *The
 * fourth release (sales and service on the phone)*; decisions 4640, 4641, 4680
 * and 4721, the bottom bar's More; 9340, the person's own arrangement), spread into the one string lookup beside the earlier batches' words. A
 * word the web already says, such as To-Dos, Pending Approvals, Awaiting your
 * decision, My Jobs or Sign Out, is read from the web's own key and is not
 * repeated here.
 */
export const DRAWER_STRINGS = {
  'mobile.bar.more': 'More',
  'mobile.home.title': 'Home',
  'mobile.whatsNew.gotIt': 'Got It',
  'mobile.whatsNew.sinceLast': 'What changed since you last opened the app.',
  // Decision 9300, row T3130: Awaiting your decision, the page Home's Pending Approvals count opens.
  'mobile.approvals.needsSignal': 'Awaiting your decision is read only with a signal, and this phone keeps none of it. Pull down to read again once it has one.',
  'mobile.approvals.none': 'Nothing waits on your decision.',
  'mobile.approvals.onWeb': 'decided on the web',
  // Decision 9340, row T3131: Arrange Home and Bar, the person's own quick actions and bar slots.
  'mobile.arrange.title': 'Arrange Home and Bar',
  'mobile.arrange.home': 'Home Quick Actions',
  'mobile.arrange.bar': 'Bottom Bar',
  'mobile.arrange.barFixed': 'Home and More stay at the two ends of the bar.',
  'mobile.arrange.homeFull': 'Home holds four quick actions. Remove one to add another.',
  'mobile.arrange.barFull': 'The bar holds three pages between Home and More. Remove one to add another.',
  'mobile.arrange.nothingLeft': 'Every page your role shows is already here.',
  'mobile.arrange.none': 'None yet',
  'mobile.arrange.add': 'Add',
  'mobile.arrange.choose': 'Add a Page',
  'mobile.arrange.up': 'Up',
  'mobile.arrange.down': 'Down',
  'mobile.arrange.remove': 'Remove',
  'mobile.arrange.reset': 'Reset to Default',
  'mobile.arrange.saved': 'Your Home and bar are saved.',
  'mobile.arrange.resetDone': 'Your Home and bar are back to the default.',
  'mobile.arrange.needsSignal': 'Saving needs a signal. Try again once the phone has one.',
} as const;
